import React, { Component } from 'react'
import HeaderStructure from '../../../structures/header/index'

class Header extends Component {
  constructor(props) {
    super(props)
    this.id = 'header'
    this.type = 'header'
  }

  static defaultProps = {
    id: 'header',
    preset: '1',
    meta: {}
  };

  // 通过结构库中预设的结构生成最终的 dom
  render() {
    const structure = new HeaderStructure(this.props)
    return (
      <div className="site-header">
        { structure.current() }
      </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/site_layout/header/index.js